module.exports = {
	"naslov": "Pripreme za ustanak",
	"slika": "fotke/1941/1941-05-komunisti-vezbaju-pucanje.jpg",
	"opis": "Sa članovima ilegalne Komunističke partije Jugoslavije izašao si van grada da vežbaš rukovanje oružjem. Ako okupaciona vlast sazna za ovo, ti i čitava tvoja porodica ćete biti internirani u koncentracione logore.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Ostaću sa partizanima!",
			"link": "1941-07-07-zakletva"
		},
		{
			"opis": "Prećiću četnicima!",
			"link": "oj-cetnici"
		},
		{
			"opis": "Vratiću se kući.",
			"link": "1941-09-24-sabac"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/05-15/pripreme.json
// module id = 40
// module chunks = 0